import React, { useEffect } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import "../../css/landing.css";
const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (<section>
    <main className="page-container landing-page-container">
      <Header />
      <section id="privacy">
        <div className="container mt-3">
          <h1 className=" my-3 "><b>About Us</b></h1>
        </div>
        <div className="container">
          <h4 className="mb-3 mt-5"><b>This page is under construction</b></h4>
        </div>
      </section>
      <Footer />
    </main>
  </section>)
};

export default Privacy;
